import {
  trigger,
  transition,
  group,
  query,
  style,
  animate,
  state,
} from '@angular/animations';

function toLeft(_: any, toState: any): boolean {
  return toState.toLeft === true;
}
function toRight(_: any, toState: any): boolean {
  return toState.toLeft === false;
}
export const slideRoundHidden = trigger('slideRoundChild', [
  state('in', style({ display: 'block' })),
  transition('void => *', animate(0)),
  transition(
    (_, toState, _element, params) =>
      toState === 'in' && params?.['toLeft'] === true,
    [
      style({ transform: 'translateX(-100%)', display: 'block' }),
      animate('300ms ease-in', style('*')),
    ]
  ),
  transition(
    (fromState, _, _element, params) =>
      fromState === 'in' && params?.['toLeft'] === true,
    [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }),
      animate('300ms ease-in', style({ transform: 'translateX(100%)' })),
    ]
  ),
  transition(
    (_, toState, _element, params) =>
      toState === 'in' && params?.['toLeft'] === false,
    [
      style({ transform: 'translateX(100%)', display: 'block' }),
      animate('300ms ease-in', style('*')),
    ]
  ),
  transition(
    (fromState, _, _element, params) =>
      fromState === 'in' && params?.['toLeft'] === false,
    [
      style({
        transform: 'translateX(0%)',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }),
      animate('300ms ease-in', style({ transform: 'translateX(-100%)' })),
    ]
  ),
]);

export const slideRound = trigger('slideRound', [
  // Disable initial page load animation
  transition('void => *', animate(0)),
  transition(
    toLeft,
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)' }),
          animate('300ms ease-in', style('*')),
        ],
        { optional: true }
      ),
      query(
        ':leave',
        [
          style({
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }),
          animate('300ms ease-in', style({ transform: 'translateX(100%)' })),
        ],
        { optional: true }
      ),
    ])
  ),
  transition(
    toRight,
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(100%)' }),
          animate('300ms ease-in', style('*')),
        ],
        { optional: true }
      ),
      query(
        ':leave',
        [
          style({
            transform: 'translateX(0%)',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }),
          animate('300ms ease-in', style({ transform: 'translateX(-100%)' })),
        ],
        { optional: true }
      ),
    ])
  ),
]);
